// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkout-service[data-v-65fdf21e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  min-height: 100vh;\n}\n.checkout-service__markdown[data-v-65fdf21e] {\n  margin-top: 80px;\n  margin-bottom: 80px;\n  padding: 0 60px;\n}\n", ""]);
// Exports
module.exports = exports;
